import React from 'react';

import { useNarrowViewport } from '../utils/use-narrow-viewport';
import PencilIcon from './pencil-icon';
import { currentWinner, initialSets, isDrawn, isInProgress } from './scoring-match-draft';
import ScoringMatchSides from './scoring-match-sides';
import type { MatchItem, ScoringSystem } from './scoring-types';

interface Props {
  match: MatchItem;
  canSubmit: boolean;
  scoring?: ScoringSystem;
  showRating?: boolean;
  onOpen?: () => void;
}

export const ScoringMatchCard: React.FC<Props> = ({ match, canSubmit, scoring, showRating = false, onOpen }) => {
  const savedWinner = currentWinner(match);
  const drawn = isDrawn(match);
  const inProgress = isInProgress(match);
  const narrow = useNarrowViewport();

  return (
    <li
      data-testid={`scoring-match-${match.id}`}
      className={inProgress ? 'scoring-match-card scoring-match-card--partial' : 'scoring-match-card'}
    >
      <div className="scoring-match-header" role={onOpen ? 'button' : undefined} onClick={onOpen}>
        <ScoringMatchSides
          match={match}
          sets={initialSets(match)}
          winner={savedWinner}
          scoring={scoring}
          showRating={showRating}
          compact={narrow}
          drawn={drawn}
        />
        {savedWinner === null && !drawn && (
          <div className="scoring-match-meta">
            {inProgress ? (
              <span
                data-testid={`match-${match.id}-partial`}
                className="scoring-match__partial"
                title="Zapisane skończone sety — mecz trwa, wynik jeszcze nie liczy się do tabeli"
              >
                W trakcie
              </span>
            ) : (
              <span data-testid={`match-${match.id}-planned`} className="scoring-match__pending">
                {canSubmit ? 'Wpisz wynik' : 'Brak wyniku'}
              </span>
            )}
          </div>
        )}
        {canSubmit && onOpen && (
          <button
            type="button"
            className="scoring-match__edit"
            data-testid={`match-${match.id}-edit`}
            aria-label="Wpisz wynik"
            title="Wpisz wynik"
            onClick={(event) => {
              event.stopPropagation();
              onOpen();
            }}
          >
            <PencilIcon />
          </button>
        )}
      </div>
    </li>
  );
};

export default ScoringMatchCard;
